module.exports = __webpack_public_path__ + "1fb24309cc5353bc7e1e007dde5ecf09.pdf";